module.exports = __webpack_public_path__ + "static/img/logo2.db3b16e9.png";